import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Modal from "react-modal";
import CommonStructured from "../../common-components/CommonStructured";
import { useGetFetchNew } from "../../../data/Queries";
import { selectUser } from "../../auth/auth.selector";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import SLAForm from "./SLAForm";
import "../../../styles/ticket-system/sla-rules.css";
import "../../../styles/ticket-system/ticket-status-badges.css";
import { EditIcon } from "../../../images/icons/website-icons";
import { ticketSystemSlaRules } from "../../../data/ApiEndpoints";

const SLARules = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);
  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);

  const {
    data: slaRulesData,
    isLoading: slaRulesLoading,
    refetch: refetchSlaRules,
  } = useGetFetchNew({
    token: userInfoData?.token,
    key: "sla_rules",
    url: ticketSystemSlaRules,
    filters: {
      limit: pageLimit || 10,
      page: isPage + 1,
    },
  });

  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  const onCloseModal = () => {
    setModValues(iniModvalues);
  };

  // Format status display
  const formatStatus = (status) => {
    if (!status) return "";
    return status.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
  };

  // Calculate total time in readable format
  const formatTimeLimit = (days, hours, minutes) => {
    const parts = [];
    if (parseInt(days) > 0) parts.push(`${days}d`);
    if (parseInt(hours) > 0) parts.push(`${hours}h`);
    if (parseInt(minutes) > 0) parts.push(`${minutes}m`);
    return parts.length > 0 ? parts.join(" ") : "0m";
  };

  // Get status badge class (using existing ticket system badges)
  const getStatusBadgeClass = (status) => {
    return `ticket-system-status-badge status-${status?.toLowerCase()}`;
  };

  const slaRulesColumns = [
    {
      dataField: "transition",
      text: <p className="table__header">Status Transition</p>,
      formatter: (cell, row) => {
        return (
          <div className="sla-transition-cell">
            <div className="transition-flow">
              <div className="status-badge-container">
                <span className={getStatusBadgeClass(row?.current_status)}>
                  {formatStatus(row?.current_status)}
                </span>
                <div className="transition-arrow">→</div>
                <span className={getStatusBadgeClass(row?.next_status)}>
                  {formatStatus(row?.next_status)}
                </span>
              </div>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "time_limit",
      text: <p className="table__header">Time Limit (SLA)</p>,
      formatter: (cell, row) => {
        return (
          <div className="sla-time-cell">
            <div className="time-display">
              <span className="time-value">
                {formatTimeLimit(row?.days, row?.hours, row?.minutes)}
              </span>
              <small className="time-breakdown">
                {parseInt(row?.days) > 0 && (
                  <span className="time-part">{row.days} days</span>
                )}
                {parseInt(row?.hours) > 0 && (
                  <span className="time-part">{row.hours} hours</span>
                )}
                {parseInt(row?.minutes) > 0 && (
                  <span className="time-part">{row.minutes} minutes</span>
                )}
              </small>
            </div>
            <div className="total-minutes">
              <small>Total: {row?.allowed_minutes} minutes</small>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "status",
      text: <p className="table__header">Status</p>,
      formatter: (cell, row) => {
        const isActive = row?.status === "active";
        return (
          <span
            className="tb-data sla-status-badge"
            style={{
              background: isActive ? "#28a745" : "#dc3545",
              color: "#fff",
              padding: "6px 12px",
              borderRadius: "20px",
              fontSize: "12px",
              fontWeight: "600",
              textTransform: "uppercase",
            }}
          >
            {isActive ? "Active" : "Inactive"}
          </span>
        );
      },
    },
    {
      dataField: "last_updated",
      text: <p className="table__header">Last Updated</p>,
      formatter: (cell, row) => {
        return (
          <div className="sla-date-cell">
            <p className="tb-data table__Text">
              {row?.last_updated
                ? moment(row.last_updated).format("DD-MM-YYYY")
                : "-"}
            </p>
            <small className="date-time">
              {row?.last_updated
                ? moment(row.last_updated).format("hh:mm A")
                : ""}
            </small>
          </div>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn danger"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardName: "edit",
                rowData: row,
              }))
            }
            title="Edit SLA Rule"
          >
            <EditIcon />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="sla-rules-container">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="SLA Rule Modal"
          ariaHideApp={false}
          //   className="sla-modal"
          //   overlayClassName="sla-modal-overlay"
        >
          <SLAForm
            refetchSlaRules={refetchSlaRules}
            onCloseModal={onCloseModal}
            modValues={modValues}
            setModValues={setModValues}
            token={userInfoData?.token}
          />
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"SLA Rules Management"}
              subHeading={
                "Manage Service Level Agreement rules for ticket status transitions"
              }
              onClickCreateBtn={() => refetchSlaRules()}
              isReload={() => refetchSlaRules()}
            />
          </Col>
        </Row>

        <div className="sla-info-section">
          <div className="sla-info-card">
            <div className="info-icon">ℹ️</div>
            <div className="info-content">
              <h6>About SLA Rules</h6>
              <p>
                SLA rules define the maximum allowed time for ticket status
                transitions. Rules are predefined and can only be updated. When
                a ticket exceeds the defined time limit for a status transition,
                it's considered as breaching the SLA.
              </p>
            </div>
          </div>
        </div>

        <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table sla-table-container">
          {slaRulesLoading ? (
            <ReactVortoxSpinner />
          ) : (
            <PaymentLinkTable
              tableColumns={slaRulesColumns}
              tableData={slaRulesData?.data}
              tablePagination={slaRulesData?.pagination}
              isPage={isPage}
              setIsPage={(value) => setIsPage(value)}
              setPageLimit={setPageLimit}
              pageLimit={pageLimit}
              isFirstColSticky={true}
            />
          )}
        </div>

        {slaRulesData?.data?.length === 0 && !slaRulesLoading && (
          <div className="sla-empty-state">
            <div className="empty-icon">📋</div>
            <h5>No SLA Rules Found</h5>
            <p>
              SLA rules will appear here once they are configured in the system.
            </p>
          </div>
        )}
      </Container>
    </div>
  );
};

export default SLARules;
